import { useShipFromValidation } from '../../../../ship-from/components/ship-from-dropdown/validator';

const ShipFromValidator = ({ children, selectedShipFromId, shipFroms, selectedCarrierId }) => {
  const validation = useShipFromValidation({
    selectedShipFromId,
    shipFroms,
    selectedCarrierId,
  });

  return children({ validation });
};

export default ShipFromValidator;
